import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      d: "M11.556 16h.888v-4.889h-.888zM12 9.846a.53.53 0 0 0 .39-.157.53.53 0 0 0 .157-.39.53.53 0 0 0-.158-.39.53.53 0 0 0-.389-.157.537.537 0 0 0-.547.548q0 .231.158.389a.53.53 0 0 0 .389.157M12.003 20a7.8 7.8 0 0 1-3.12-.63 8.1 8.1 0 0 1-2.542-1.71 8.1 8.1 0 0 1-1.71-2.538A7.8 7.8 0 0 1 4 12.002q0-1.659.63-3.12.63-1.46 1.708-2.54a8 8 0 0 1 2.54-1.712 7.8 7.8 0 0 1 3.12-.63q1.657 0 3.12.63 1.46.63 2.54 1.709 1.082 1.08 1.712 2.54t.63 3.118q0 1.659-.63 3.12a8.1 8.1 0 0 1-1.71 2.542 8.1 8.1 0 0 1-2.538 1.71q-1.458.633-3.12.631M12 19.111q2.978 0 5.044-2.067 2.067-2.066 2.067-5.044t-2.067-5.044T12 4.889 6.956 6.956Q4.889 9.022 4.889 12t2.067 5.044Q9.022 19.111 12 19.111"
    }, null, -1)
  ]))]))
}
export default { render: render }